import {useContext} from 'react';
import {ServerContext} from 'coreUtils/adapters/sdk';

export interface CacheTagManager {
	addContentfulTag(id?: string): void;
	addProductTag(id?: string): void;
	addCategoryTag(id?: string): void;
}

/**
 * Subset of the Express response augmented with app-specific helpers.
 * Available only during SSR; `useSSRResponse()` returns `null` on the client.
 */
export interface SSRResponse {
	statusCode: number;
	/** True once the shell was flushed (Vite brands stream the document, see `coreUtils/ssrShell`). */
	headersSent?: boolean;
	setCache?(seconds: number): void;
	cacheTagManager?: CacheTagManager;
	locals?: Record<string, unknown>;
}

/**
 * Provides access to the Express `res` object during SSR.
 * Returns `null` on the client.
 *
 * Useful inside `useServerData` queryFns to set cache headers,
 * cache tags, or status codes while the response is still being built.
 */
const useSSRResponse = (): SSRResponse | null => {
	const ctx = useContext(ServerContext) as {res?: SSRResponse} | null;

	return ctx?.res ?? null;
};

export default useSSRResponse;
